<template>
  <div class="app">
    <overdue-notice v-if="!isRoot && isAuthorized" />
    <AppHeader fixed class="bg-gray-dark pr-md-5 pr-sm-1">
      <div class="d-flex align-items-center bg-dark nav-bar-header">
        <SidebarToggler class="d-lg-none" display="md" mobile/>
        <router-link class="navbar-brand d-none d-lg-flex" :to="'/'">
          <img class="navbar-brand-full" src="@/../public/img/brand/logo_white.svg" height="34" alt="Wallkit">
<!--          <ChristmasLogo style="height: 34px"/>-->
        </router-link>
        <SidebarToggler class="d-md-down-none" display="lg" style="outline: none!important"/>
      </div>

      <div v-if="!!availableResources.length" class="resource-select-container ml-md-5 ml-sm-3 mr-4">
        <multiselect
          deselectLabel=""
          class="resource-select border-primary"
          v-model="selected"
          track-by="value"
          label="label"
          @select="selectResource"
          :options="availableResources"
          :searchable="true"
          :allow-empty="false"
          select-label=""
          selected-label="">
          <template slot="noResult">
            {{$t('global.no_results')}}
          </template>
          <template slot="singleLabel" slot-scope="{ option }">
            {{ option.label }}
          </template>
          <template slot="option" slot-scope="{ option }" class="pl-1">
            {{ option.label }}
          </template>
        </multiselect>
      </div>

      <div v-if="selected" class="resource-settings-container">
        <b-btn :to="`/resources/edit?resource=${selected.value}`"
               variant="outline-light"
               class="resource-settings-button">
          <i style="font-size: larger" class="icon-settings mr-sm-2"></i>
          <span class="resource-settings-button__title">{{$t('global.resource_settings')}}</span>
        </b-btn> 
      </div>

      <div class="ml-auto">
        <b-btn
          href="https://wallkit.notion.site/wallkit/Wallkit-fb866edce3a44824b6efc7acf72a5396"
          target="_blank"
          variant="outline-light"
          class="resource-settings-button"
        >
          <i style="font-size: larger" class="icon-notebook mr-sm-2" />
          <span class="resource-settings-button__title">
            {{ $t('global.knowledge_base') }}
          </span>
        </b-btn>
      </div>

      <b-navbar-nav class="ml-2 d-none d-sm-block">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav" class="text-white"/>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" class="pl-md-5 mb-3"/>
        <div class="px-md-5 px-2">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <!--<TheFooter>-->
    <!--&lt;!&ndash;footer&ndash;&gt;-->
    <!--<div>-->
    <!--<a href="https://coreui.io">CoreUI</a>-->
    <!--<span class="ml-1">&copy; 2018 creativeLabs.</span>-->
    <!--</div>-->
    <!--<div class="ml-auto">-->
    <!--<span class="mr-1">Powered by</span>-->
    <!--<a href="https://coreui.io">CoreUI for Vue</a>-->
    <!--</div>-->
    <!--</TheFooter>-->
  </div>
</template>

<script>
  import nav from '@/_nav'
  import {get} from 'lodash';
  import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb
  } from '@coreui/vue'
  import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
  import ChristmasLogo from "../components/global/christmasLogo";
  import OverdueNotice from '../components/global/OverdueNotice.vue';

  export default {
    name: 'full',
    components: {
      ChristmasLogo,
      AsideToggler,
      AppHeader,
      AppSidebar,
      AppAside,
      TheFooter,
      Breadcrumb,
      DefaultHeaderDropdownAccnt,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer,
      OverdueNotice
    },
    data() {
      return {
        nav: [...nav.items],
        options: [],
        resource: {},
      }
    },
    computed: {
      user() {
        return this.$store.getters['auth/user']
      },
      selected: {
        get: function () {
          return {
            value: get(this.$store.getters['resource/currentResource'], 'key'),
            label: get(this.$store.getters['resource/currentResource'], 'title')
          };
        },
        set: function (newValue) {
        }
      },
      availableResources() {
        return this.$store.getters['resource/availableResources'].map(r => {
          if (r) {
            return {value: r.key, label: r.title};
          }
        });
      },
      name() {
        return this.$route.name
      },
      list() {
        return this.$route.matched.filter((route) => route.name || route.meta.label)
      },
      isRoot() {
        return this.$store.getters['auth/role'] === 'root';
      },
      isAuthorized() {
        return this.$store.getters['auth/isAuthorized'];
      },
    },
    mounted () {
      let partnersObject = {
        name: "Partners",
            url: "/partners",
            icon: "icon-partners",
            badge: {
          variant: "primary"
        }
      }
      let wallkitPricingObject = {
        name: "Wallkit Pricing",
            url: "/wallkit-pricing",
            icon: "icon-pricing",
            badge: {
          variant: "primary"
        }
      }
      let wallkitInvoicesObject = {
        name: "Invoices",
        url: "/invoices",
        icon: "icon-calculator",
        badge: {
          variant: "primary"
        }
      }
      let cascadeAccessObject = {
        name: "Cascade Access",
        url: "/cascade-access",
        icon: "icon-organization",
        badge: {
          variant: "primary"
        }
      }
      let indexOfPartners = _.findIndex(this.nav, (o) => { return _.isMatch(o, partnersObject) })
      let indexOfwallkitPricing = _.findIndex(this.nav, (o) => { return _.isMatch(o, wallkitPricingObject) })
      let indexOfwallkitInvoices = _.findIndex(this.nav, (o) => { return _.isMatch(o, wallkitInvoicesObject) })
      let indexOfCascadeAccess = _.findIndex(this.nav, (o) => { return _.isMatch(o, cascadeAccessObject) })
      if (this.user.role === "root") {
        if (indexOfPartners === -1) {
          this.$set(this.nav, this.nav.length,
              partnersObject
          )
        }
        if(indexOfwallkitPricing === -1) {
          this.$set(this.nav, this.nav.length, wallkitPricingObject)
        }
        if(indexOfwallkitInvoices === -1) {
          this.$set(this.nav, this.nav.length, wallkitInvoicesObject)
        }
        if(indexOfCascadeAccess === -1) {
          this.$set(this.nav, this.nav.length, cascadeAccessObject)
        }
      } else if(this.user.role === "partner"){
        if(indexOfCascadeAccess === -1) {
          this.$set(this.nav, this.nav.length, cascadeAccessObject)
        }
      } else {
        if (indexOfPartners !== -1) {
          this.nav.splice(indexOfPartners, 1)
          indexOfwallkitPricing = _.findIndex(this.nav, (o) => { return _.isMatch(o, wallkitPricingObject) })
        }
        if(indexOfwallkitPricing !== -1) {
          this.nav = this.nav.splice(indexOfwallkitPricing, 1)
        }
      }
    },
    methods: {
      selectResource({value}) {
        this.$store.dispatch('resource/updateResource', value);
      }
    }
  }
</script>
